import { launchError, launchSuccess } from "components/notifications";
import { updateUserFeatures } from "services/fetchUserById";
import { updateUserAppFeatures } from "services/userServices";
import './userFeatures.css'
import { useTranslation } from "react-i18next";




const UserFeatures = ({ features, userData, setFeatures, setUserData, user, id }) => {

    const { t } = useTranslation();
    const handleFeatureChange = (feature, status) => {
    setFeatures(prevFeatures => ({
      ...prevFeatures,
      [feature]: status,
    }));
  };

  const handleUserFeatureChange = (feature, status) => {
    const newUserData = { ...userData };
    userData.user_features[feature] = status
    setUserData(newUserData)
  };

    const confirmFeatures = async () => {
      try {
        // Create an object with the feature states
        const featuresToUpdate = {
          deposit: features.deposit === 'enabled',
          withdraw: features.withdraw === 'enabled',
          invest: features.invest === 'enabled',
        };
        // Call the API to update the user features
        await updateUserFeatures(user, id, featuresToUpdate); // Replace with your actual API call
  
        launchSuccess(t('notifications.users.userById.update.success'));
      } catch (error) {
        console.error('Error updating features:', error);
        launchError(t('notifications.users.userById.update.error'));
      }
    };
  
  
    const confirmUserAppFeatures = async () => {
      try {
        // Call the API to update the user features
        await updateUserAppFeatures(user, id, { ...userData.user_features, user_uuid: id });
  
        launchSuccess(t('notifications.users.userById.update.success'));
      } catch (error) {
        console.error('Error updating features:', error);
        launchError(t('notifications.users.userById.update.error'));
      }
    };


  return <div className='userData_case'>
    <p className='user_doc_title'>User Features :</p>
    <div className='userData_features'>
      <div className='userData_featuresinfo userData_box'>
        <table>
          <thead>
            <tr>
              <th>Features</th>
              <th className="center">Enabled</th>
              <th className="center">Disabled</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(features).map(([feature, status]) => (
              <tr key={feature}>
                <td>{feature.toUpperCase()}</td>
                <td className="center">
                  <input
                    type="radio"
                    name={feature}
                    value="enabled"
                    checked={status === 'enabled'}
                    onChange={() => handleFeatureChange(feature, 'enabled')}
                  />
                </td>
                <td className="center">
                  <input
                    type="radio"
                    name={feature}
                    value="disabled"
                    checked={status === 'disabled'}
                    onChange={() => handleFeatureChange(feature, 'disabled')}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='userData_update_features' onClick={confirmFeatures}>Valider</button>
      </div>

      <div className='userData_featuresinfo userData_box'>
        <table>
          <thead>
            <tr>
              <th>User Features</th>
              <th className="center">Enabled</th>
              <th className="center">Disabled</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(userData.user_features)?.map(([feature, status]) => (
              <tr key={feature}>
                <td>{feature.toUpperCase()}</td>
                <td className="center">
                  <input
                    type="radio"
                    name={feature}
                    value={true}
                    checked={status}
                    onChange={() => handleUserFeatureChange(feature, !status)}
                  />
                </td>
                <td className="center">
                  <input
                    type="radio"
                    name={feature}
                    value={false}
                    checked={!status}
                    onChange={() => handleUserFeatureChange(feature, !status)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='userData_update_features' onClick={confirmUserAppFeatures}>Valider</button>
      </div>
    </div>
  </div>
}


export default UserFeatures;